<template>
    <v-row v-if="!$store.getters.progress" class="ma-0">
		<v-col class="pa-0">
            <show
                :id="id"
                :models="models"
                model-def="pricelists"
                model-class="pricelist"
                :infos="infos"
                top-class=""
                :activities="true">
                <template slot="relations">
                    <v-col class="pa-0 pb-4" v-if="headers">
                        <v-card class="flex pa-0 background-2 round-card">
                            <v-card-title class="pa-3"><p class="pl-2 pl-xl-3">Prodotti</p>
                                <v-spacer></v-spacer>
                                <v-row class="pa-0 ma-0" v-show="expand">
                                    <v-text-field class="hidden-xs-only font-weight-regular"
                                        append-icon="search"
                                        label="Cerca"
                                        v-model="search"
                                        clearable
                                        hide-details
                                        background-color="background-2"
                                        outlined
                                        dense               
                                    ></v-text-field>
                                </v-row>
                                <v-switch
                                    class="px-4 pt-0"
                                    style="margin: auto !important"
                                    label="Validi Oggi"
                                    hide-details
                                    inset
                                    v-model="subFilters['active_today']"
                                    color="primary"
                                ></v-switch>                                        

                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" @click="expand = !expand" icon>
                                            <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
                                        </v-btn>
                                    </template>                    
                                    <span>{{ expand ? 'Contrai' : 'Espandi' }}</span>
                                </v-tooltip>           
                            </v-card-title>

                            <v-divider v-show="expand"></v-divider>

                            <v-container class="py-0" fluid v-show="expand">
                                <v-row class="ma-0">
                                    <v-col cols="12" class="hidden-sm-and-up pa-3">
                                        <v-text-field
                                            append-icon="search"
                                            label="Cerca"
                                            v-model="search"
                                            clearable
                                            hide-details
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                            <v-expand-transition>
                                <v-container class="pa-0" fluid v-show="expand">			  
                                    <v-row class="ma-0 pa-0">
                                        <v-col cols="12" class="pa-0 pb-1">
                                            <v-card class="flex" elevation="0">
                                                <v-data-table
                                                    :options.sync="pagination"
                                                    :server-items-length="pagination.totalItems"
                                                    :headers="headers"
                                                    :items="items"
                                                    item-key="id"
                                                    :search="search"
                                                    :loading="loading"
                                                    :mobile-breakpoint="0"
                                                    class="background-2"
                                                    :footer-props="{
                                                        'items-per-page-options': [10, 25, 50,  { text: 'Tutti', value: -1 }]
                                                    }">
                                                    <template v-slot:item="{ item, headers }">
                                                        <tr class="cursor-pointer">
                                                            <template v-for="(header, h) in headers">
                                                                <td v-if="header.type == 'currency'" :class="'text-xs-'+header.align" :key="h">
                                                                    {{ item[header.value] | currency }}
                                                                </td>
                                                                <td v-else-if="header.type == 'date'" :class="'text-xs-'+header.align" :key="h">
                                                                    {{ item[header.value] | date }}
                                                                </td>
                                                                <td v-else :class="'text-xs-'+header.align" :key="h">
                                                                    {{ item[header.value] }}
                                                                </td>
                                                            </template>
                                                        </tr>
                                                    </template>
                                                    <template v-slot:footer.page-text="{ pageStart, pageStop }">
                                                        Da {{ pageStart }} a {{ pageStop }} di {{ pagination.totalItems }}
                                                    </template>
                                                </v-data-table>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-expand-transition>
                        </v-card>
                    </v-col>
                </template>
            </show>
        </v-col>
    </v-row>
</template>

<script>

    import BelongstomanyShow from '@/components/common/BelongstomanyShow'

    export default {
        name: 'pricelist',
        components: {
            BelongstomanyShow
        },

        props: {
            id: Number,
        },

        data() {
            return {
                loading: false,
                infos: {},
                models: {},
                pricelistproduct_info: {},
                subFilters: {'pricelists': this.id, 'active_today': true},
                search: '',
                expand: true,
                apiTimeout: null,
                items: [],
                pagination:  {
                    'sortBy': ['id'],
                    'sortDesc': [false],
                    'page': 1,
                    'itemsPerPage': 10,
                    'totalItems': 0,
                },                
            }
        },

        computed: {

            headers() {
                return this.pricelistproduct_info.fieldDefs                
            }

        },
        
        watch: {
            'pagination.sortBy': {
                handler(newValue, oldValue) {
                    if(oldValue !== newValue) {
                        this.getPricelistProduct()
                    }
                },
            },
            'pagination.sortDesc': {
                handler(newValue, oldValue) {
                    if(oldValue !== newValue) {
                        this.getPricelistProduct()
                    }
                },
            },
            'pagination.page': {
                handler(newValue, oldValue) {
                    this.getPricelistProduct()
                },
            },
            'pagination.itemsPerPage': {
                handler(newValue, oldValue) {
                    if(oldValue !== newValue) {
                        this.getPricelistProduct()
                    }
                },
            },

            search: {
                handler() {
                    if(this.pagination.page !== 1) {
                        this.$set(this.pagination, 'page', 1)
                    }
                    this.getPricelistProduct()
                }
            },

            'subFilters.active_today': { 
                handler() {
                    this.getPricelistProduct()
                }
            }
        },        

        methods: {

            getPricelistProduct() {

                if(this.apiTimeout) {
                    clearTimeout(this.apiTimeout)
                }

                this.apiTimeout = setTimeout(() => {            
                    this.loading = true
                        
                    let dataObject = {
                        page: this.pagination.page,
                        per_page: this.pagination.itemsPerPage,
                        sortBy: this.pagination.sortBy,
                        sortDesc: this.pagination.sortDesc,
                        filter: this.search,
                        subFilters: this.subFilters,
                    }

                    this.axios.post('pricelist-product-pricelist-filters', dataObject).then(response => {
                        this.loading = false
                        this.items = response.data.data.data
                        this.pagination.totalItems = response.data.data.total

                    }, response => {
                        // error callback
                        this.loading = false
                    })
                }, 500)
            },

            getPricelist() {
                this.loading = true
                this.axios.get('pricelists/' + this.id).then(response => {
                    this.models = response.data.models
                    this.infos = response.data.infos
                    this.$store.commit('endProgress')
                    this.loading = false

                }, response => {
                    // error callback
                })
            },

            getPricelistProductInfo() {
                return new Promise((resolve, reject) => {
                    this.axios.get('pricelist-product-pricelist-info/').then(response => {
                        response.data.info.fieldDefs = response.data.info.fieldDefs.filter((field) => !field.actions)
                        this.pricelistproduct_info = response.data.info
                        resolve()

                    }, response => {
                        reject()
                    })                    
                })                
            }            
        },

        created() {
            this.getPricelist()

            this.getPricelistProductInfo().then(() => {
                this.getPricelistProduct()
            })
                
            this.expand = !this.$store.getters.checkSettings('compact_viewing')
             
        }
    }
</script>
